import { Component } from 'react'
import moment from 'moment'
import Timezones from '~/components/OrdersPage/Timezones'
import styles from '~/styles/ordersPage.chartDate.module.css'
import types from '~/types/ordersPage.ts'

export default class ChartDate extends Component {
	static getInitialProps() {
		return {
			namespacesRequired: [ 'Orders' ],
		}
	}
	
	constructor(props) {
		super(props)
		moment.locale(this.props.locale)
	}

	render(): JSX.Element {
		if (this.props.show) {
			let resetButton = null
			let date = moment(this.props.chartDate).format('L')
			let title = this.props.t('Chart date')
			if (this.props.chartEndDate) {
				title = this.props.t('Chart range')
			}
			return (
				<div
					className={styles.main}
				>
					<div className={styles.dateRangeReplacement + (resetButton ? '' : ' ' + styles.noReset)}>
						{this._oneDayArrow()}
						<div className={styles.title}>
							{title}:
						</div>
						<div>
							{date}
						</div>
						{this._getEndDate()}
					</div>
					<Timezones
	                  toShow='display'
	                  timezoneCode={this.props.timezoneCode}
		              setTimezoneCode={this.props.setTimezoneCode}
		              timezoneName={this.props.timezoneName}
		              setTimezoneName={this.props.setTimezoneName}
	                  t={this.props.t}
	                />
					{resetButton}
				</div>
			)
		} else {
			return null
		}
	}

	private _oneDayArrow(): JSX.Element {
		if (!this._isEndDate()) {
			const oneDayArrow = (
				<div>
					<svg viewBox="0 0 1000 1000">
						<path d="M694 242l249 250c12 11 12 21 1 32L694 773c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210-210H68c-13 0-23-10-23-23s10-23 23-23h806L662 275c-21-22 11-54 32-33z">
						</path>
					</svg>
				</div>
			)
			return oneDayArrow
		} else {
			return null
		}
	}

	private _getEndDate(): JSX.Element {
		if (this._isEndDate()) {
			const endDate = moment(this.props.chartEndDate).format('L')
			const endDateJsx = (
				<>
					<div
						className={styles.hyphen}
					>
						–
					</div>
					<div>
						{endDate}
					</div>
				</>
			)
			return endDateJsx
		} else {
			return null
		}
	}

	private _isEndDate(): JSX.Element {
		let isEndDate = false
		if (this.props.chartEndDate) {
			if (this.props.chartIntervalType !== 'day') {
				if (this.props.chartNpsPerIntervalType !== 'day') {
					isEndDate = true
				}
			}
		}
		return isEndDate
	}

	private _onClick(): void {
		if (typeof this.props.removeChartDateAndStatus === 'function') {
			this.props.removeChartDateAndStatus()
		}
	}
}